!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):e.dlv=n()}(this,function(){return function(e,n,t,o){for(o=0,n=n.split?n.split("."):n;e&&o<n.length;)e=e[n[o++]];return void 0===e?t:e}});
//# sourceMappingURL=dlv.umd.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/dlv/dist/dlv.umd.js
 ** module id = 98
 ** module chunks = 1
 **/